import React from 'react';
import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { SponsoredMessageModel } from '@mm/state/model/SponsoredMessageModel';
import { StoreState } from '@mm/state/store-interfaces';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import SponsoredMessageCRUDActions from '@mm/state/actions/SponsoredMessageCRUDActions';
import modalActions from '@mm/state/modules/modalsState/actions';
import { EditHeader } from '../../../clickToMessengerAds/components/EditHeader/EditHeader';
import { DEFAULT_ENTITY_NAME } from '../../constants/constants';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';

type Props = {
  sponsoredMessage: SponsoredMessageModel | undefined;
  onSaveName: (name: string) => void;
  onSaveClick: () => void;
  showPublish: boolean;
  canPublish: boolean;
  errors?: string[];
  isTemplateBot: boolean;
};

export const EditPromoBlasterHeader = (props: Props) => {
  const {
    sponsoredMessage,
    onSaveName,
    onSaveClick,
    canPublish,
    errors,
    isTemplateBot,
    showPublish,
  } = props;
  const valid = isEmpty(errors);
  const dispatch: Dispatch<StoreState> = useDispatch();
  const chatbotId = useSelector(activeChatbotIdSelector);
  const { history } = useRouter();

  const onClickDelete = () => {
    if (!sponsoredMessage) {
      return;
    }
    const deleteCallback = async () => {
      if (sponsoredMessage !== undefined) {
        await dispatch(
          SponsoredMessageCRUDActions.delete(chatbotId, sponsoredMessage),
        );
      }

      const pathname = BotBuilderRoutes.campaigns.getLink({
        chatbotId,
        kind: 'sponsored_messages',
      });

      history.push(pathname);
    };

    dispatch(
      modalActions.openDeleteConfirmModal({
        headerText: 'Are you sure you want to delete this sponsored message?',
        deleteCallback,
      }),
    );
  };

  return (
    <EditHeader
      defaultName={DEFAULT_ENTITY_NAME}
      valid={valid}
      entity={sponsoredMessage === undefined ? null : sponsoredMessage}
      errors={errors}
      saveButtonClass="edit-header__save-button"
      saveButtonText={sponsoredMessage?.draft === false ? 'Save' : 'Send'}
      onClickDelete={onClickDelete}
      onSaveName={onSaveName}
      showSave={showPublish}
      onSaveClick={onSaveClick}
      saveDisabled={!sponsoredMessage || !canPublish || isTemplateBot}
    />
  );
};
